'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['', '.network.offline'], ['', '.network.offline']),
    _templateObject2 = _taggedTemplateLiteral(['offline'], ['offline']);

var _operators = require('cerebral/operators');

var _tags = require('cerebral/tags');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = function (path) {
  return [(0, _operators.set)((0, _tags.state)(_templateObject, path), (0, _tags.props)(_templateObject2))];
};
//# sourceMappingURL=offlineChanged.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/useragent/lib/signalFactories/offlineChanged.js
// module id = 761
// module chunks = 1